import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/Branch'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({ commit, dispatch }, payload) {
    let url = 'api/Branch'
    let params = {
      'street': payload.event.item.street,
      'city': payload.event.item.city,
      'state': payload.event.item.state,
      'sat_pais_id': payload.event.item.sat_pais_id,
      'zip_code': payload.event.item.zip_code,
      'branch_name': payload.event.item.branch_name
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({ commit, dispatch }, payload) {
    let url = 'api/Branch/' + payload.event.item.id
    let params = {
      'street': payload.event.item.street,
      'city': payload.event.item.city,
      'state': payload.event.item.state,
      'sat_pais_id': payload.event.item.sat_pais_id,
      'zip_code': payload.event.item.zip_code,
      'branch_name': payload.event.item.branch_name
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/Branch/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getBranchesCompanies ({ commit, dispatch }, payload) {
    let url = 'api/branches-company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetBranchesCompanies', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  postBranchesCompanies ({ commit, dispatch }, payload) {
    let url = 'api/branches-company'
    let params = {
      'company_id': payload.event.item.company.id,
      'branch_id': payload.event.item.id
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPostBranchesCompanies', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  deleteBranchesCompanies ({ commit, dispatch }, payload) {
    let url = 'api/branches-company/' + payload.event.originalCompanyId + '/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          // commit('onDeleteBranchesCompanies', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the branches endpoint
  onGet (state, payload) {
    let branches = payload.response.data.data
    payload.event.context.branches = branches
    payload.event.context.pagination.totalItems = branches.length
    this.dispatch('branches/getBranchesCompanies', { event: payload.event })
    payload.event.context.loadingItems = false
  },
  // Add the data from the new branch to the branches list
  onPost (state, payload) {
    let branch = payload.response.data.data
    branch.company = {}
    branch.company.id = payload.event.item.company.id
    payload.event.item.id = branch.id
    if (payload.event.item.company.id !== null) {
      this.dispatch('branches/postBranchesCompanies', { event: payload.event })
    }
    let branches = []
    if (payload.event.context.branches) {
      branches = payload.event.context.branches
    }
    branches.push(branch)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Updates the data displayed for the modified branch
  onPut (state, payload) {
    // Assign the local edited branch to a variable
    let branch = payload.response.data.data
    // Commented because the endpoint is currently returning a true value in data from response
    // let branch = payload.response.data.data
    let branches = []
    if (payload.event.context.userLogged.roles[0].id === 1) {
      branches = payload.event.context.branches
    } else if (payload.event.context.userLogged.roles[0].id === 2) {
      branches = payload.event.context.branchesByCompany.branch
    }
    branches.splice(payload.event.index, 1, branch)
    // payload.event.context.branches = branches
    // if (payload.event.originalCompanyId !== null && payload.event.item.company.id !== payload.event.originalCompanyId) {
    //   this.dispatch('branches/deleteBranchesCompanies', { event: payload.event })
    // }
    // if (payload.event.item.company.id !== payload.event.originalCompanyId) {
    //   this.dispatch('branches/postBranchesCompanies', { event: payload.event })
    // }
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Removes the data of the deleted branch from the branches list
  onDelete (state, payload) {
    payload.event.context.closeDelete()
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  },
  onErrorManual (state, payload) {
    payload.event.context.showNotification(payload.error, 'error')
  },
  // Set the data obtained from the branches companies endpoint
  onGetBranchesCompanies (state, payload) {
    let branchesCompanies = payload.response.data.data
    payload.event.context.branchesCompanies = branchesCompanies
    payload.event.context.branches.forEach(branch => {
      branch.company = {}
      branch.company.id = null
      branchesCompanies.forEach(branchCompany => {
        branchCompany.branch.forEach(branchCompanyBranch => {
          if (branchCompanyBranch.id === branch.id) {
            branch.company = branchCompany
          }
        })
      })
    })
    payload.event.context.processedBranches = payload.event.context.branches
  },
  onPostBranchesCompanies (state, payload) {
    payload.event.context.refresh()
    // payload.event.context.showNotification(payload.response, 'success')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/branches.js